import { render } from "./MarkdownField.vue?vue&type=template&id=10469347"
import script from "./MarkdownField.vue?vue&type=script&lang=js"
export * from "./MarkdownField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MarkdownField.vue"]])

export default __exports__